import { TaskService } from "./task.service";



export const services = [
    TaskService,
]


export * from "./task.service";